export const breakpoints = {
    mobile: '530px',
    tablet: '768px',
};



// WEBPACK FOOTER //
// ./src/constants.js